import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { request } from "@/lib/request";
import { TemplateCategory } from "@/lib/types";
import { useUser } from "../useUserProvider";

type UseGetTemplateCategoriesOptions = Omit<
  UseQueryOptions<TemplateCategory[], Error>,
  "queryKey" | "queryFn"
>;

export const useGetTemplateCategories = ({
  enabled = true,
  ...options
}: UseGetTemplateCategoriesOptions = {}) => {
  const { accessToken } = useUser();

  return useQuery({
    ...options,
    queryKey: ["template-categories", accessToken],
    enabled: !!accessToken && enabled,
    queryFn: async () => {
      if (!accessToken) {
        throw new Error("You need to be logged in to load template categories.");
      }

      const res = await request
        .get<{ data: TemplateCategory[] }>("/templates/categories")
        .catch(err => {
          throw new Error(
            err.response?.data.message
              ? err.response?.data.message
              : "Failed to load template categories.",
          );
        });

      return res.data.data;
    },
  });
};
